import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { metricAdapter } from '@/entities/metrics/model/metric.slice';

const baseSelectors = metricAdapter.getSelectors(
	(state: RootState) => state.metrics,
);

const selectByCanonicalName = createSelector(
	[baseSelectors.selectAll, (_, canonicalName: string) => canonicalName],
	(allMetrics, canonicalName) =>
		allMetrics.find((metric) => metric.canonicalName === canonicalName),
);

const metricSliceSelectors = {
	...baseSelectors,
	selectByCanonicalName,
};

export { metricSliceSelectors };
